import axios from 'axios';
import { useEffect, useState } from 'react';
import { Fade } from 'react-awesome-reveal';
import { Link, useLocation, useParams } from 'react-router-dom';
import PageLoader from '../../components/global/loader/PageLoader';
import { InternalBanner } from '../../components/internals/InternalBanner';
import { removeBaseUrl } from '../../utils';

import './styles.scss';
const Category = () => {
    const { slug } = useParams();
    const [isFetching, setIsFetching] = useState(false);
    const [isFetchingBaseInfo, setIsFetchingBaseInfo] = useState(false);
    const [blogs, setBlogs] = useState([]);
    const [pageNo, setPageNo] = useState(1);
    const location = useLocation();
    const [hasMore, setHasMore] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [queryParam, setQueryParam] = useState('');
    const [categoryObj, setCategoryObj] = useState(null);

    useEffect(() => {
        window.scrollTo(0, 0);
        document.title = 'Medical Malpractice Lawyer NYC';
        fetchCategoryBaseInfo(slug);
    }, [slug]);

    useEffect(() => {
      const queryParams = new URLSearchParams(window.location.search);
      const paramValue = queryParams.get('keyword');
      setQueryParam(paramValue);
      setBlogs([]);
      setPageNo(1);
    }, [location]);

    const fetchCategoryBaseInfo = async (slug) => {
        try {
            setIsFetchingBaseInfo(true);
            const { data } = await axios.get(`/wp-admin/admin-ajax.php?action=get_category_by_name&slug=${slug}`);
            setCategoryObj(data?.category ?? null);
            setSelectedCategory(data?.category?.term_id);
            document.title = `${data?.category?.cat_name} - Medical Malpractice Lawyer NYC`;
        } catch (err) {
            console.log(err);
        } finally {
            setIsFetchingBaseInfo(false);
        }
    }

    const fetchBlogs = async (pageNo, keyword, cat_id) => {
        if (isFetching) {
            return;
        }

        if (pageNo == 1) {
            setBlogs([]);
        }

        try {
            setIsFetching(true);
            const { data } = await axios.get(`/wp-admin/admin-ajax.php?action=fetch_articles_by_pagination&paged=${pageNo}&keyword=${keyword}&category=${cat_id?cat_id:-1}`);
            setCurrentPage(Number(data?.paged));
            if (data?.result?.length > 0) {
                setBlogs([...blogs, ...data?.result]);
            }
            setHasMore(Number(data?.size) >= 9);
        } catch (err) {
            console.log(err);
        } finally {
            setIsFetching(false);
        }
    };

    useEffect(() => {
        if (selectedCategory) {
            fetchBlogs(pageNo, '', selectedCategory);
        }

    }, [pageNo, selectedCategory]);

    

    return  <Fade delay={1}>        
            <main id="main" className='internal-page'>
                {!isFetchingBaseInfo &&  <>
                    <InternalBanner page={{ post_title: `Category: ${categoryObj?.cat_name}` }} />
                    <section id="main-blogs-section" className='internal-page-section'>
                        <div className='container'>
                            <div className='page-content blog-content'>
                                <div className='blog-list'>
                                    {
                                        blogs?.map((it, index) => <div className='article' key={index}>
                                            <img src={it?.featured_image} className="featured-image" />
                                            <div className='article-meta'>
                                                <span className='date'>{it?.post_date}</span>
                                                <Link to={removeBaseUrl(it?.link)} className='title'>{it?.title}</Link>
                                            </div>
                                        </div>)
                                    }
                                </div>
                                {hasMore && <div className="read-more">
                                    <span className="btn-load-more" data-page={currentPage + 1} onClick={()=>{
                                        setPageNo(currentPage + 1);
                                    }} data-wpel-link="internal">
                                        Load more
                                        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                                            <mask id="mask0_762_478" style={{maskType: 'alpha'}} maskUnits="userSpaceOnUse" x="0" y="0" width="21" height="21">
                                                <rect x="21" width="21" height="21" transform="rotate(90 21 0)" fill="#D9D9D9"></rect>
                                            </mask>
                                            <g mask="url(#mask0_762_478)">
                                                <path d="M1.75 7.02188L3.30312 5.46875L10.5 12.6656L17.6969 5.46875L19.25 7.02188L10.5 15.7719L1.75 7.02188Z" fill="#001233"></path>
                                            </g>
                                        </svg>
                                    </span>
                                </div>}
                            </div>
                        </div>
                    </section>
                </>}
                {
                    isFetchingBaseInfo && <PageLoader />
                }
            </main>
        </Fade>
}


export default Category;